import { HorizontalCardGroup } from '@ps/isp-web-component-library';
import type { TemplateView } from '@ps/isp-web-services-types';
import React from 'react';

import { OddsBoostPanelHeader } from '@swf/sports/components';

import styles from './OddsBoostEvents.scss';
import OddsBoostEventCard from './components/OddsBoostEventCard/OddsBoostEventCard';

interface Props {
  oddsBoostEvents: TemplateView[];
}

export const OddsBoostEvents: React.FC<Props> = ({ oddsBoostEvents }) => (
  <>
    <OddsBoostPanelHeader />
    <HorizontalCardGroup className={styles.cardGroup}>
      {oddsBoostEvents.map((oddsBoostItem) =>
        oddsBoostItem.template.templateId === 'ODDS_BOOST' ? (
          <OddsBoostEventCard
            key={`${oddsBoostItem.template.marketId}-${oddsBoostItem.template.templateId}`}
            marketId={oddsBoostItem.template.marketId}
          />
        ) : null
      )}
    </HorizontalCardGroup>
  </>
);
